module.exports = __webpack_public_path__ + "static/media/entregarinju4.400f1231.webp";